webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(34);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(90);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _kernel = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  router: _kernel.router,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	}).$mount('#app');

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'app'
	};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Topbar = __webpack_require__(96);
	
	var _Topbar2 = _interopRequireDefault(_Topbar);
	
	var _Purchases = __webpack_require__(94);
	
	var _Purchases2 = _interopRequireDefault(_Purchases);
	
	var _Tickets = __webpack_require__(95);
	
	var _Tickets2 = _interopRequireDefault(_Tickets);
	
	var _About = __webpack_require__(93);
	
	var _About2 = _interopRequireDefault(_About);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'index',
	  components: {
	    Topbar: _Topbar2.default,
	    Purchases: _Purchases2.default,
	    Tickets: _Tickets2.default,
	    About: _About2.default
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(45);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      doc: '',
	      message: null
	    };
	  },
	
	  methods: {
	    login: function login() {
	      var _this = this;
	
	      var query = {
	        "query": '{person_by_document(document: "' + this.doc + '"){\n                    id\n                    name\n                    email\n                    document\n                    gender\n                    observation\n                    phone}}'
	      };
	      this.getEvent().then(function (response) {
	        _this.$http.post(('http://api-evento-v2.ignicaodigital.com.br/v2/client'), query).then(function (response) {
	          if (!response.data.data.person_by_document) {
	            _this.message = true;
	            _this.$router.replace('/');
	            return;
	          }
	          localStorage.setItem("data", (0, _stringify2.default)(response.data.data.person_by_document));
	          _this.$router.replace('/index');
	        }, function (response) {
	          if (response.status == 401) {
	            window.localStorage.setItem('message', true);
	            _this.message = window.localStorage.getItem('message');
	            _this.$route.router.go({ name: 'login' });
	          }
	        });
	      });
	    },
	    getEvent: function getEvent() {
	      var query = {
	        "query": '{event(id: ' + (41) + '){\n            id\n            name\n            description\n            address\n            quantity\n            start_date\n            end_date\n            start_hour\n            end_hour\n            client_app\n          }\n        }'
	      };
	
	      return this.$http.post(('http://api-evento-v2.ignicaodigital.com.br/v2/client'), query).then(function (response) {
	        localStorage.setItem("event", (0, _stringify2.default)(response.body.data.event));
	      });
	    }
	  }
	};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(46);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      event: {},
	      start_date: new Date(),
	      end_date: new Date(),
	      month_event: null
	    };
	  },
	
	  mounted: function mounted() {
	    this.getEvent();
	    this.formatFullDates();
	    this.embedDescription();
	  },
	  methods: {
	    getEvent: function getEvent() {
	      this.event = JSON.parse(localStorage.getItem('event'));
	    },
	    formatFullDates: function formatFullDates() {
	      var _start_date, _end_date;
	
	      this.start_date = new (Function.prototype.bind.apply(Date, [null].concat((0, _toConsumableArray3.default)(this.event.start_date.split('-').map(function (item, indice) {
	        return item - indice % 2;
	      })))))();
	      this.end_date = new (Function.prototype.bind.apply(Date, [null].concat((0, _toConsumableArray3.default)(this.event.end_date.split('-').map(function (item, indice) {
	        return item - indice % 2;
	      })))))();
	      this.month_event = this.start_date.toLocaleString('pt-BR', {
	        month: "long"
	      }).replace(/\b\w/g, function (l) {
	        return l.toUpperCase();
	      });
	      (_start_date = this.start_date).setHours.apply(_start_date, (0, _toConsumableArray3.default)(this.event.start_hour.split(/[\:/\-/\'UTC'\' ']/).splice(3, 5)));
	      (_end_date = this.end_date).setHours.apply(_end_date, (0, _toConsumableArray3.default)(this.event.end_hour.split(/[\:/\-/\'UTC'\' ']/).splice(3, 5)));
	    },
	    embedDescription: function embedDescription() {
	      document.querySelector("#info").innerHTML = this.event.description;
	    }
	  }
	};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      sales: [],
	      person: {},
	      canCreate: { disabled: true, modal: '' },
	      purchases: [],
	      participant: { gender: -1, ticket: { id: -1 } },
	      showModal: false,
	      saleId: '',
	      formSubmitted: false
	    };
	  },
	
	  mounted: function mounted() {
	    this.listSale();
	  },
	  methods: {
	    validateBeforeSubmit: function validateBeforeSubmit(e) {
	      this.$validator.validateAll();
	      if (!this.errors.any()) {
	        this.submitForm();
	      }
	    },
	    submitForm: function submitForm() {
	      this.formSubmitted = true;
	    },
	    listSale: function listSale() {
	      var _this = this;
	
	      this.person = JSON.parse(localStorage.getItem("data"));
	
	      var query = {
	        "query": '{\n          sales_active_by_event(person: ' + this.person.id + ', event: ' + (41) + ') {\n            id\n            quantity\n            is_free\n            ticket {\n              id\n              name\n              observation\n              event {\n                id\n                name\n                description\n                start_date\n                end_date\n                start_hour\n                end_hour\n                address\n              }\n            }\n            guests {\n              person {\n                id\n                name\n              }\n            }\n          }\n        }'
	      };
	
	      this.$http.post(('http://api-evento-v2.ignicaodigital.com.br/v2/client'), query).then(function (response) {
	        _this.sales = response.body.data.sales_active_by_event;
	      }, function (response) {
	        console.log(response);
	      });
	    },
	    openModal: function openModal(saleId) {
	      this.saleId = saleId;
	      this.showModal = true;
	    },
	    createParticipant: function createParticipant() {
	      var _this2 = this;
	
	      var person = {
	        "query": 'mutation createPerson {\n          createPerson(input: {\n            name: "' + this.participant.name + '"\n            email: "' + this.participant.email + '"\n            document: "' + this.participant.document + '"\n            gender: ' + this.participant.gender + '\n            observation: ""\n            phone: "' + this.participant.phone + '"\n            person_category_id: 1\n            }){\n            person {\n              id\n              name\n              email\n              document\n              gender\n              observation\n              phone\n              central_user_id\n              type {\n                id\n                name\n              }\n            }\n            message\n          }\n        }'
	      };
	
	      this.getPerson(this.participant.document).then(function (response) {
	        var personId = void 0;
	        if (!response) {
	          _this2.$http.post(('http://api-evento-v2.ignicaodigital.com.br/v2/client'), person).then(function (response) {
	            personId = response.body.data.createPerson.person.id;
	            _this2.saveParticipant(personId);
	          });
	        } else {
	          personId = response.id;
	          _this2.saveParticipant(personId);
	        }
	      });
	    },
	    saveParticipant: function saveParticipant(personId) {
	      var _this3 = this;
	
	      var event = JSON.parse(localStorage.getItem("event"));
	      var participant = {
	        "query": 'mutation createParticipant {\n          createParticipant(input: {\n            observation: ""\n            sale_id: ' + this.saleId + '\n            event_id: ' + event.id + '\n            person_id: ' + personId + '\n            status: 1\n          }){\n            participant {\n              observation\n            }\n          }\n        }'
	      };
	
	      this.getParticipant(event.id, personId).then(function (response) {
	        if (!response) {
	          _this3.$http.post(('http://api-evento-v2.ignicaodigital.com.br/v2/client'), participant).then(function (response) {
	            _this3.showModal = false;
	            location.reload();
	          });
	        } else {
	          console.log("participante já cadastrado");
	        }
	      });
	    },
	    getPerson: function getPerson(document) {
	      var query = {
	        "query": '{\n          person_by_document(document: "' + document + '"){\n            id\n            name\n            email\n            document\n            gender\n            observation\n            phone\n          }\n        }'
	      };
	
	      return this.$http.post(('http://api-evento-v2.ignicaodigital.com.br/v2/client'), query).then(function (response) {
	        return response.body.data.person_by_document;
	      });
	    },
	    getParticipant: function getParticipant(eventId, personId) {
	      var query = {
	        "query": '{\n          participant(event_id: ' + eventId + ', person_id: ' + personId + '){\n            person{\n              id\n              name\n            }\n          }\n        }'
	      };
	
	      return this.$http.post(('http://api-evento-v2.ignicaodigital.com.br/v2/client'), query).then(function (response) {
	        return response.body.data.participant;
	      });
	    }
	  }
	};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      guests: [],
	      person: this.$router.person
	    };
	  },
	
	  mounted: function mounted() {
	    this.listTickets();
	  },
	  methods: {
	    statusReturn: function statusReturn(status) {
	      console.log(status);
	      switch (status) {
	        case 1:
	          return 'Ativo';
	          break;
	        case 3:
	          return 'Cancelado';
	          break;
	      }
	    },
	    listTickets: function listTickets() {
	      var _this = this;
	
	      var person = JSON.parse(localStorage.getItem("data"));
	
	      var query = {
	        "query": '{\n          sales_by_event(person: ' + person.id + ', event: ' + (41) + ') {\n            guests {\n              status\n              event {\n                id\n                name\n              }\n              person {\n                id\n                name\n                document\n                email\n                phone\n              }\n              sale {\n                id\n                ticket{\n                  name\n                }\n              }\n            }\n          }\n        }'
	      };
	
	      this.$http.post(('http://api-evento-v2.ignicaodigital.com.br/v2/client'), query).then(function (response) {
	        var sales = response.body.data.sales_by_event;
	        _this.guests = [];
	        sales.map(function (sale) {
	          if (sale.guests.length !== 0) sale.guests.map(function (guest) {
	            return _this.guests.push(guest);
	          });
	        });
	      }, function (response) {
	        console.log(response);
	      });
	    },
	    deleteTicket: function deleteTicket(guest) {
	      var _this2 = this;
	
	      swal({
	        title: "Você tem certeza?",
	        text: 'Deseja remover ticket de ' + guest.person.name + ' da lista de convidados!',
	        type: "warning",
	        showCancelButton: true,
	        confirmButtonColor: "#DD6B55",
	        confirmButtonText: "Sim, confirmar !",
	        cancelButtonText: "Não, cancelar !",
	        closeOnConfirm: true,
	        closeOnCancel: false
	      }, function (isConfirm) {
	        if (isConfirm) {
	          var query = {
	            "query": 'mutation destroyParticipant {\n               destroyParticipant(input: { person_id: ' + guest.person.id + ', event_id: ' + guest.event.id + ' }) {\n                 participant { observation }\n                 message\n               }\n              }'
	          };
	
	          _this2.$http.post(('http://api-evento-v2.ignicaodigital.com.br/v2/client'), query).then(function (response) {
	            var msg = {
	              title: "Participante apagado",
	              text: 'O participante foi apagado com sucesso',
	              type: "success",
	              hide: true
	            };
	            location.reload();
	          });
	        } else {
	          swal("Cancelado", "Participante não foi excluído!", "error");
	        }
	      });
	    },
	    isBuyer: function isBuyer(guest) {
	      var person = JSON.parse(localStorage.getItem("data"));
	      return guest.person.id != person.id;
	    }
	  }
	};

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'topbar',
	  data: function data() {
	    return {};
	  },
	
	  methods: {
	    logout: function logout() {
	      localStorage.removeItem("data");
	      localStorage.removeItem("event");
	      this.$router.replace('/');
	    }
	  }
	};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueRouter = __webpack_require__(33);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _Index = __webpack_require__(91);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Login = __webpack_require__(92);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routes = [{ path: '/', name: 'login', component: _Login2.default }, { path: '/index', name: 'index', component: _Index2.default }];
	
	exports.default = new _vueRouter2.default({
	  mode: 'history',
	  routes: routes
	});

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.router = undefined;
	
	var _vue = __webpack_require__(34);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(33);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _router = __webpack_require__(42);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _vueResource = __webpack_require__(104);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _sweetalert = __webpack_require__(87);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _veeValidate = __webpack_require__(89);
	
	var _veeValidate2 = _interopRequireDefault(_veeValidate);
	
	__webpack_require__(73);
	
	__webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dictionary = {
	  en: {
	    messages: {
	      required: function required() {
	        return "Campo obrigatório";
	      },
	      email: function email() {
	        return "Digite um email válido";
	      }
	    }
	  }
	};
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_sweetalert2.default);
	_vue2.default.use(_veeValidate2.default);
	
	exports.router = _router2.default;

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(77)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(35),
	  /* template */
	  __webpack_require__(99),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(79)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(36),
	  /* template */
	  __webpack_require__(102),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(80)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(37),
	  /* template */
	  __webpack_require__(103),
	  /* scopeId */
	  "data-v-f565fa2c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(38),
	  /* template */
	  __webpack_require__(100),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(75)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(39),
	  /* template */
	  __webpack_require__(97),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(78)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(40),
	  /* template */
	  __webpack_require__(101),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(76)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(41),
	  /* template */
	  __webpack_require__(98),
	  /* scopeId */
	  "data-v-54136ae4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 97 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box"
	  }, [_c('article', {
	    staticClass: "media"
	  }, [_c('div', {
	    staticClass: "media-content"
	  }, [_c('div', {
	    staticClass: "content"
	  }, [_c('p', [_c('strong', [_vm._v("Olá, " + _vm._s(_vm.person.name) + " ")]), _vm._v(" "), _c('br'), _vm._v("\n          Confira abaixo os seus tickets para o evento\n        ")]), _vm._v(" "), _c('table', {
	    staticClass: "table"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.sales), function(sale) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(sale.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(sale.ticket.event.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(sale.ticket.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(sale.quantity) + "/" + _vm._s(sale.guests.length))]), _vm._v(" "), _c('td', [_c('a', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (sale.guests.length !== sale.quantity),
	        expression: "sale.guests.length !== sale.quantity"
	      }],
	      staticClass: "button is-success is-outlined",
	      attrs: {
	        "title": "adiciona ticket"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.openModal(sale.id)
	        }
	      }
	    }, [_vm._m(1, true)])])])
	  }), 0)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal active",
	    class: {
	      'is-active': _vm.showModal
	    }
	  }, [_c('div', {
	    staticClass: "modal-background"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "modal-card"
	  }, [_vm._m(2), _vm._v(" "), _c('section', {
	    staticClass: "modal-card-body"
	  }, [(!_vm.formSubmitted) ? _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.validateBeforeSubmit.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "control"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.participant.name),
	      expression: "participant.name"
	    }],
	    staticClass: "input",
	    class: {
	      'is-danger': _vm.errors.has('name')
	    },
	    attrs: {
	      "name": "name",
	      "type": "text",
	      "placeholder": "NOME COMPLETO DO PARTICIPANTE"
	    },
	    domProps: {
	      "value": (_vm.participant.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.participant, "name", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('name')),
	      expression: "errors.has('name')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('name')))])]), _vm._v(" "), _c('div', {
	    staticClass: "control"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.participant.email),
	      expression: "participant.email"
	    }],
	    staticClass: "input",
	    class: {
	      'is-danger': _vm.errors.has('email')
	    },
	    attrs: {
	      "name": "email",
	      "type": "text",
	      "placeholder": "EMAIL"
	    },
	    domProps: {
	      "value": (_vm.participant.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.participant, "email", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('email')),
	      expression: "errors.has('email')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), _c('div', {
	    staticClass: "control"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.participant.phone),
	      expression: "participant.phone"
	    }],
	    staticClass: "input",
	    class: {
	      'is-danger': _vm.errors.has('phone')
	    },
	    attrs: {
	      "name": "phone",
	      "type": "text",
	      "placeholder": "TELEFONE DE CONTATO"
	    },
	    domProps: {
	      "value": (_vm.participant.phone)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.participant, "phone", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('phone')),
	      expression: "errors.has('phone')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), _c('div', {
	    staticClass: "control"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.participant.document),
	      expression: "participant.document"
	    }],
	    staticClass: "input",
	    class: {
	      'is-danger': _vm.errors.has('document')
	    },
	    attrs: {
	      "name": "document",
	      "type": "text",
	      "placeholder": "NÚMERO DO DOCUMENTO (APENAS NÚMEROS)",
	      "onkeypress": "return (event.which >= 48 && event.which <= 57) || event.which == 8 || event.which == 0 || event.which == 46"
	    },
	    domProps: {
	      "value": (_vm.participant.document)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.participant, "document", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('document')),
	      expression: "errors.has('document')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), _c('div', {
	    staticClass: "control"
	  }, [_c('select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.participant.gender),
	      expression: "participant.gender"
	    }],
	    staticClass: "select",
	    class: {
	      'is-danger': _vm.errors.has('gender')
	    },
	    attrs: {
	      "name": "gender"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.participant, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "-1"
	    }
	  }, [_vm._v("Sexo")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("Feminino")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Masculino")])])]), _vm._v(" "), _c('div', {
	    staticClass: "control"
	  }, [_c('button', {
	    staticClass: "button is-info",
	    class: {
	      'is-disabled': _vm.errors.length > 0
	    },
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.createParticipant()
	      }
	    }
	  }, [_vm._v("Salvar")]), _vm._v(" "), _c('a', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.showModal = false
	      }
	    }
	  }, [_vm._v("Cancel")])])]) : _vm._e()])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Quantidade/Usados")]), _vm._v(" "), _c('th', [_vm._v("Ações")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon is-small"
	  }, [_c('i', {
	    staticClass: "fa fa-ticket"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "modal-card-head"
	  }, [_c('p', {
	    staticClass: "modal-card-title"
	  }, [_vm._v("Adiciona Ticket")])])
	}]}

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', {
	    staticClass: "nav"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "nav-right nav-menu"
	  }, [_c('span', {
	    staticClass: "nav-item"
	  }, [_c('a', {
	    staticClass: "button is-primary is-outlined",
	    on: {
	      "click": function($event) {
	        return _vm.logout()
	      }
	    }
	  }, [_c('span', [_vm._v("SAIR")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "nav-left"
	  }, [_c('a', {
	    staticClass: "nav-item"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/logo.png",
	      "alt": "Bulma logo"
	    }
	  })])])
	}]}

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box",
	    staticStyle: {
	      "margin-bottom": "50px"
	    }
	  }, [_c('article', {
	    staticClass: "media"
	  }, [_c('div', {
	    staticClass: "media-content"
	  }, [_c('div', {
	    staticClass: "content"
	  }, [_c('h3', [_c('strong', [_vm._v("Informações do evento: " + _vm._s(_vm.event.name) + " ")])]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "margin-bottom": "20px"
	    }
	  }, [_c('b', {
	    staticStyle: {
	      "font-weight": "bold"
	    }
	  }, [_vm._v("Data:")]), _vm._v(" " + _vm._s(this.start_date.getDate()) + " a " + _vm._s(this.end_date.getDate()) + " de " + _vm._s(this.month_event)), _c('br'), _c('br'), _vm._v(" "), _c('b', {
	    staticStyle: {
	      "font-weight": "bold"
	    }
	  }, [_vm._v("Horário:")]), _vm._v(" " + _vm._s(this.start_date.getHours()) + "hs as " + _vm._s(this.end_date.getHours()) + "hs"), _c('br'), _c('br'), _vm._v(" "), _c('b', {
	    staticStyle: {
	      "font-weight": "bold"
	    }
	  }, [_vm._v("Local:")]), _vm._v(" " + _vm._s(_vm.event.address)), _c('br'), _c('br'), _vm._v(" "), _c('b', {
	    staticStyle: {
	      "font-weight": "bold"
	    }
	  }, [_vm._v("LEIA AS INFORMAÇÕES ABAIXO:")]), _c('br')]), _c('p', {
	    attrs: {
	      "id": "info"
	    }
	  }), _c('br'), _vm._v(" "), _c('p')])])])])
	},staticRenderFns: []}

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box"
	  }, _vm._l((_vm.guests), function(guest) {
	    return _c('article', {
	      staticClass: "media"
	    }, [_c('div', {
	      staticClass: "media-content"
	    }, [_c('div', {
	      staticClass: "content"
	    }, [_c('h5', {
	      staticStyle: {
	        "color": "#008000"
	      }
	    }, [_vm._v(_vm._s(guest.event.name) + "(" + _vm._s(guest.sale.ticket.name) + ")")]), _vm._v(" "), (_vm.isBuyer(guest)) ? _c('button', {
	      staticClass: "delete is-large deletebtn",
	      on: {
	        "click": function($event) {
	          return _vm.deleteTicket(guest)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v("Status: ")]), _vm._v(_vm._s(_vm.statusReturn(guest.status))), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Participante: ")]), _vm._v(_vm._s(guest.person.name)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Documento: ")]), _vm._v(_vm._s(guest.person.document)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Email: ")]), _vm._v(_vm._s(guest.person.email)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Telefone: ")]), _vm._v(_vm._s(guest.person.phone) + "\n      ")])])])
	  }), 0)
	},staticRenderFns: []}

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('topbar'), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('purchases'), _vm._v(" "), _c('h2', {
	    staticClass: "title is-2 centered"
	  }, [_vm._v("Tickets")]), _vm._v(" "), _c('tickets'), _vm._v(" "), _c('about')], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "control pagination-centered"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/logo.png",
	      "alt": "logo"
	    }
	  }), _vm._v(" "), (_vm.message) ? _c('article', {
	    staticClass: "message is-warning"
	  }, [_c('div', {
	    staticClass: "message-header"
	  }, [_c('p', [_vm._v("Aviso")]), _vm._v(" "), _c('button', {
	    staticClass: "delete",
	    on: {
	      "click": function($event) {
	        _vm.message = false
	      }
	    }
	  })]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "control has-icon has-icon-left"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.doc),
	      expression: "doc"
	    }],
	    staticClass: "input",
	    attrs: {
	      "type": "text",
	      "placeholder": "Numero do documento",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.doc)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.doc = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
	    staticClass: "control"
	  }, [_c('button', {
	    staticClass: "button",
	    attrs: {
	      "type": "button",
	      "disabled": !_vm.doc
	    },
	    on: {
	      "click": function($event) {
	        return _vm.login()
	      }
	    }
	  }, [_vm._v("Entrar")])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "message-body"
	  }, [_c('p', [_vm._v("Seu usuario não esta cadastrado neste evento.")]), _vm._v(" "), _c('p', [_vm._v("Favor entrar em contato com o nosso suporte através do email "), _c('a', {
	    attrs: {
	      "href": "mailto:alunos@formuladelancamento.com.br"
	    }
	  }, [_vm._v("alunos@formuladelancamento.com.br")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon",
	    staticStyle: {
	      "color": "#f0a939"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user"
	  })])
	}]}

/***/ }),
/* 104 */,
/* 105 */,
/* 106 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.ae2e0c38c31353a1d1f0.js